import React from 'react'

import OpKeywordAdvancedSetting from './OpKeywordAdvancedSetting'
import FieldRow from './FieldRow'
import FieldNumber from './FieldNumber'

// Unprofitable Targets
const OpKeywordProfit = ({ settings, onChange, ...props }) => {
  const validateAcos = acosField => () => {
    if (settings[acosField] === ''
      || isNaN(settings[acosField])
      || parseFloat(settings[acosField]) < 0) {
      onChange(acosField, 0)
    }
  }

  return (
    <>
      <OpKeywordAdvancedSetting
        isOriginal
        tooltip="These are targets that are close to your target ACoS and can use some bid adjustments. The Apply Genius Bid action setting is ideal for this."
        settings={settings}
        onChange={onChange}
        {...props}
      >
        <FieldRow>
          <div className="field-wrapper">
            <div className="field-name">
              ACoS % Between (%)
            </div>
            <input
              type="number"
              className="shrinked-input"
              min="0"
              value={settings['op_adv_genius_bid_min_acos']}
              onChange={(event) => { onChange('op_adv_genius_bid_min_acos', event.target.value) }}
              onBlur={validateAcos('op_adv_genius_bid_min_acos')}
            />
            <span className="input-desc">to</span>
            <input
              type="number"
              className="shrinked-input"
              min="0"
              value={settings['op_adv_genius_bid_max_acos']}
              onChange={(event) => { onChange('op_adv_genius_bid_max_acos', event.target.value) }}
              onBlur={validateAcos('op_adv_genius_bid_max_acos')}
            />
            {
              parseFloat(settings['op_adv_genius_bid_min_acos'])
              > parseFloat(settings['op_adv_genius_bid_max_acos']) && (
                <div className="acos-warning">
                  Please enter a valid ACoS range.
                </div>
              )
            }
          </div>
          <FieldNumber
            label="With at least this many clicks"
            field="op_adv_genius_bid_clicks"
            settings={settings}
            onChange={onChange}
          />
        </FieldRow>
      </OpKeywordAdvancedSetting>
      {
        settings[`copy_${props.prefix}active`] && (
          <OpKeywordAdvancedSetting
            settings={settings}
            onChange={onChange}
            {...props}
          >
            <FieldRow>
              <div className="field-wrapper">
                <div className="field-name">
                  ACoS % Between (%)
                </div>
                <input
                  type="number"
                  className="shrinked-input"
                  min="0"
                  value={settings['copy_op_adv_genius_bid_min_acos']}
                  onChange={(event) => { onChange('copy_op_adv_genius_bid_min_acos', event.target.value) }}
                  onBlur={validateAcos('copy_op_adv_genius_bid_min_acos')}
                />
                <span className="input-desc">to</span>
                <input
                  type="number"
                  className="shrinked-input"
                  min="0"
                  value={settings['copy_op_adv_genius_bid_max_acos']}
                  onChange={(event) => { onChange('copy_op_adv_genius_bid_max_acos', event.target.value) }}
                  onBlur={validateAcos('copy_op_adv_genius_bid_max_acos')}
                />
                {
                  parseFloat(settings['copy_op_adv_genius_bid_min_acos'])
                  > parseFloat(settings['copy_op_adv_genius_bid_max_acos']) && (
                    <div className="acos-warning">
                      Please enter a valid ACoS range.
                    </div>
                  )
                }
              </div>
              <FieldNumber
                label="With at least this many clicks"
                field="copy_op_adv_genius_bid_clicks"
                settings={settings}
                onChange={onChange}
              />
            </FieldRow>
          </OpKeywordAdvancedSetting>
        )
      }
    </>
  )
}

export default OpKeywordProfit
